import { createContext } from "react";

interface StorageContextType {
  userId: string | undefined;
  conversationId: string | undefined;
}

export const StorageContext = createContext<StorageContextType | undefined>(undefined);
export type { StorageContextType };
